import { render, staticRenderFns } from "./chat-textarea.vue?vue&type=template&id=2a3233cd&scoped=true&"
import script from "./chat-textarea.vue?vue&type=script&lang=js&"
export * from "./chat-textarea.vue?vue&type=script&lang=js&"
import style0 from "./chat-textarea.vue?vue&type=style&index=0&id=2a3233cd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3233cd",
  null
  
)

export default component.exports